<template>
  <div class="energy-management-platform">
    <!-- 背景装饰 -->
    <div class="background-decoration">
      <div class="grid-overlay"></div>
      <div class="blue-glow"></div>
    </div>

    <!-- 顶部标题栏 -->
    <header class="top-header">
      <div class="header-left">
        <div class="logo">
          <div class="logo-icon">⚡</div>
          <h2>能碳管理监控平台</h2>
        </div>
        <nav class="main-nav">
          <ul class="nav-list">
            <li class="nav-item">
              <a href="#" class="nav-link active">冷源站监控</a><!--实时监控-->
            </li>
            <li class="nav-item">
              <a href="#" class="nav-link" @click.stop="toggleDeviceList">设备列表</a>
            </li>
            <li class="nav-item">
              <a href="#/carbon-emission" class="nav-link">碳排放</a>
            </li>
            <li class="nav-item">
              <a href="#/carbon-emission" class="nav-link">空压机节能</a>
            </li>
            <li class="nav-item">
              <a href="#/carbon-emission" class="nav-link">冷热源节能</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="header-right">
        <div class="system-status">
          <div class="status-item">
            <div class="status-dot online"></div>
            <span>系统运行正常</span>
          </div>
          <div class="status-item">
            <span class="status-value">{{ currentTime }}</span>
          </div>
        </div>
        <el-dropdown trigger="click" @command="handleCommand">
          <div class="user-info">
            <span>{{ username }}</span>
            <div class="user-avatar">👤</div>
          </div>
          <el-dropdown-menu slot="dropdown" class="dark-dropdown-menu">
            <el-dropdown-item command="logout" icon="el-icon-switch-button">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </header>

    <!-- 设备列表弹窗 -->
    <div class="device-list-modal" v-if="showDeviceList">
      <div class="modal-overlay" @click="closeDeviceList"></div>
      <div class="modal-content">
        <div class="modal-header">
          <h2>设备列表</h2>
          <div class="close-btn" @click="closeDeviceList">×</div>
        </div>
        <div class="modal-body">
          <div class="device-table-container">
            <table class="device-table">
              <thead>
              <tr>
                <th>设备名称</th>
                <th>设备类型</th>
                <th>所属区域</th>
                <th>设备状态</th>
                <th>功率</th>
                <th>运行时长</th>
                <th>操作</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="device in devices" :key="device.id" :class="device.status">
                <td>{{ device.name }}</td>
                <td>{{ device.type }}</td>
                <td>{{ device.area }}</td>
                <td>
                    <span class="status-badge" :class="device.status">
                      {{ device.statusText }}
                    </span>
                </td>
                <td>{{ device.power }}KW</td>
                <td>{{ device.runTime }}</td>
                <td>
                  <button class="action-btn" @click.stop="showDeviceDetail(device)">查看详情</button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- 设备详情弹窗 -->
    <div class="device-detail-modal" v-if="showDeviceDetailModal">
      <div class="modal-overlay" @click="closeDeviceDetail"></div>
      <div class="modal-content">
        <div class="modal-header">
          <h2>设备详情</h2>
          <div class="close-btn" @click="closeDeviceDetail">×</div>
        </div>
        <div class="modal-body">
          <div class="device-detail-content">
            <div class="device-basic-info" v-if="selectedDevice">
              <h3 class="section-title">基本信息</h3>
              <div class="info-grid">
                <div class="info-item">
                  <span class="info-label">设备名称</span>
                  <span class="info-value highlight">{{ selectedDevice.name }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">设备类型</span>
                  <span class="info-value">{{ selectedDevice.type }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">所属区域</span>
                  <span class="info-value">{{ selectedDevice.area }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">设备状态</span>
                  <span class="info-value">
                    <span class="status-badge" :class="selectedDevice.status">
                      {{ selectedDevice.statusText }}
                    </span>
                  </span>
                </div>
                <div class="info-item">
                  <span class="info-label">功率</span>
                  <span class="info-value">{{ selectedDevice.power }}kW</span>
                </div>
                <div class="info-item">
                  <span class="info-label">运行时长</span>
                  <span class="info-value">{{ selectedDevice.runTime }}</span>
                </div>
              </div>
            </div>
            <div class="device-control-section">
              <h3 class="section-title">设备控制</h3>
              <div class="control-section">
                <h4 class="control-subtitle">运行频率</h4>
                <div class="frequency-control">
                  <div class="frequency-input-group">
                    <div class="frequency-input-container">
                      <input type="number" class="frequency-input" min="0" max="100" v-model.number="frequency">
                      <span class="frequency-unit">HZ</span>
                      <button class="frequency-btn" @click="updateFrequency">更新频率</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="control-section">
                <h4 class="control-subtitle">设备开关</h4>
                <div class="control-buttons">
                  <button class="control-btn start-btn" @click="startDevice">开启设备</button>
                  <button class="control-btn stop-btn" @click="stopDevice">关闭设备</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 告警详情弹窗 -->
    <div class="alarm-detail-modal" v-if="showAlarmDetailModal">
      <div class="modal-overlay" @click="closeAlarmDetail"></div>
      <div class="modal-content">
        <div class="modal-header">
          <h2>告警详情</h2>
          <div class="close-btn" @click="closeAlarmDetail">×</div>
        </div>
        <div class="modal-body">
          <div class="alarm-detail-content">
            <div class="alarm-table-container">
              <table class="alarm-table">
                <thead>
                <tr>
                  <th>设备名称</th>
                  <th>所属区域</th>
                  <th>告警原因</th>
                  <th>告警时间</th>
                  <th>处理状态</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="alarm in alarmDevices" :key="alarm.id">
                  <td>{{ alarm.deviceName }}</td>
                  <td>{{ alarm.area }}</td>
                  <td>{{ alarm.reason }}</td>
                  <td>{{ alarm.time }}</td>
                  <td>
                    <span class="status-badge" :class="alarm.status">{{ alarm.statusText }}</span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <main class="main-content">
      <!-- 切换按钮 - 红框位置 -->
      <div class="station-switch-btn" @click="switchStation">
        <span class="switch-icon">🔄</span>
        {{ currentStation === 'I' ? 'II期冷源站' : 'I期冷源站' }}
      </div>

      <!-- I期冷源站 -->
      <div v-show="currentStation === 'I'" class="hlsw-monitor-wrapper">
        <img :src="hlswImage" alt="I期冷源站" class="hlsw-full-image" />
        <div class="hlsw-data-container">
          <!-- 频率数据 -->
          <span
            class="hlsw-data-item hlsw-freq-item"
            style="left: 69.5%; top: 51%;"
            :class="{ 'running': pumpStatus.HLSW_HN1013_SB_1 === '开启' }"
          >
            1#&nbsp;{{ formatFreq(feq01) }} Hz
          </span>
          <span
            class="hlsw-data-item hlsw-freq-item"
            style="left: 69.5%; top: 63%;"
            :class="{ 'running': pumpStatus.HLSW_HN1013_SB_2 === '开启' }"
          >
            2#&nbsp;{{ formatFreq(feq02) }} Hz
          </span>
          <span
            class="hlsw-data-item hlsw-freq-item"
            style="left: 69.5%; top: 75%;"
            :class="{ 'running': pumpStatus.HLSW_HN1013_SB_3 === '开启' }"
          >
            3#&nbsp;{{ formatFreq(feq03) }} Hz
          </span>
          <span
            class="hlsw-data-item hlsw-freq-item"
            style="left: 17.5%; top: 51%;"
            :class="{ 'running': pumpStatus.HLSW_HN1013_SB_4 === '开启' }"
          >
            1#&nbsp;{{ formatFreq(feq04) }} Hz
          </span>
          <span
            class="hlsw-data-item hlsw-freq-item"
            style="left: 17.5%; top: 63%;"
            :class="{ 'running': pumpStatus.HLSW_HN1013_SB_5 === '开启' }"
          >
            2#&nbsp;{{ formatFreq(feq05) }} Hz
          </span>
          <span
            class="hlsw-data-item hlsw-freq-item"
            style="left: 17.5%; top: 75%;"
            :class="{ 'running': pumpStatus.HLSW_HN1013_SB_6 === '开启' }"
          >
            3#&nbsp;{{ formatFreq(feq06) }} Hz
          </span>

          <!-- 消息滚动提示框 -->
          <div class="hlsw-msg-box">
            <div class="hlsw-msg-scroll" :style="{ transform: `translateY(-${hlswScrollOffset}px)` }">
              <div
                class="hlsw-msg-item"
                v-for="(msg, idx) in hlswInfiniteMsgList"
                :key="idx"
                :class="{
                  'msg-running': msg.includes('正在运行'),
                  'msg-stopped': msg.includes('未开机')
                }"
              >
                {{ msg }}
              </div>
            </div>
          </div>

          <!-- 机组负荷比 -->
          <span class="hlsw-data-item hlsw-jz-number" style="left: 42%; top: 42%;">{{C1_Compressor_load_one}}%</span>
          <span class="hlsw-data-item hlsw-jz-number" style="left: 46.7%; top: 42%;">{{C1_Compressor_load_two}}%</span>
          <span class="hlsw-data-item hlsw-jz-number" style="left: 42%; top: 58%;">{{C2_Compressor_load_one}}%</span>
          <span class="hlsw-data-item hlsw-jz-number" style="left: 46.7%; top: 58%;">{{C2_Compressor_load_two}}%</span>
          <span class="hlsw-data-item hlsw-jz-number" style="left: 42%; top: 75%;">{{C3_Compressor_load_one}}%</span>
          <span class="hlsw-data-item hlsw-jz-number" style="left: 46.7%; top: 75%;">{{C3_Compressor_load_two}}%</span>

          <!-- 机组名称 -->
          <span class="hlsw-data-item hlsw-jz-number" style="left: 44.5%; top: 47%;" :style="{ color: Number(JZ_status) === 1 ? '#00cc00' : 'black' }">1#</span>
          <span class="hlsw-data-item hlsw-jz-number" style="left: 44.5%; top: 64%;" :style="{ color: Number(JZ_status1) === 1 ? '#00cc00' : 'black' }">2#</span>
          <span class="hlsw-data-item hlsw-jz-number" style="left: 44.5%; top: 80.5%;" :style="{ color: Number(JZ_status2) === 1 ? '#00cc00' : 'black' }">3#</span>

          <!-- 机组状态 -->
          <span class="hlsw-data-item hlsw-jz-status" style="left: 43%; top: 52%;" :style="{ color: Number(JZ_status) === 1 ? '#00cc00' : 'black', textAlign: 'center' }">
            {{ Number(JZ_status) === 1 ? '正在运行中' : '未开机' }}
          </span>
          <span class="hlsw-data-item hlsw-jz-status" style="left: 43%; top: 69%;" :style="{ color: Number(JZ_status1) === 1 ? '#00cc00' : 'black', textAlign: 'center' }">
            {{ Number(JZ_status1) === 1 ? '正在运行中' : '未开机' }}
          </span>
          <span class="hlsw-data-item hlsw-jz-status" style="left: 43%; top: 85.5%;" :style="{ color: Number(JZ_status2) === 1 ? '#00cc00' : 'black', textAlign: 'center' }">
            {{ Number(JZ_status2) === 1 ? '正在运行中' : '未开机' }}
          </span>

          <!-- 温度数据 -->
          <span class="hlsw-data-item" style="left: 52%; top: 49%;">&nbsp;{{ Evap_inlet_water_t }} °C</span>
          <span class="hlsw-data-item" style="left: 52%; top: 52%;">&nbsp;{{ Evap_out_water_Allt }} °C</span>
          <span class="hlsw-data-item" style="left: 35%; top: 49%;">&nbsp;{{ Cond_inlet_water_t }} °C</span>
          <span class="hlsw-data-item" style="left: 35%; top: 52%;">&nbsp;{{ Cond_out_water_t }} °C</span>

          <span class="hlsw-data-item" style="left: 52%; top: 66%;">&nbsp;{{ Evap_inlet_water_t1 }} °C</span>
          <span class="hlsw-data-item" style="left: 52%; top: 68.7%;">&nbsp;{{ Evap_out_water_Allt1 }} °C</span>
          <span class="hlsw-data-item" style="left: 35%; top: 66%;">&nbsp;{{ Cond_inlet_water_t1 }} °C</span>
          <span class="hlsw-data-item" style="left: 35%; top: 68.7%;">&nbsp;{{ Cond_out_water_t1 }} °C</span>

          <span class="hlsw-data-item" style="left: 52%; top: 85%;">&nbsp;{{ Evap_inlet_water_t2 }} °C</span>
          <span class="hlsw-data-item" style="left: 52%; top: 88%;">&nbsp;{{ Evap_out_water_Allt2 }} °C</span>
          <span class="hlsw-data-item" style="left: 35%; top: 85%;">&nbsp;{{ Cond_inlet_water_t2 }} °C</span>
          <span class="hlsw-data-item" style="left: 35%; top: 88%;">&nbsp;{{ Cond_out_water_t2 }} °C</span>
        </div>
      </div>

      <!-- II期冷源站 -->
      <div v-show="currentStation === 'II'" class="hlsw-monitor-wrapper">
        <img :src="hlsw2Image" alt="II期冷源站" class="hlsw-full-image" />
        <div class="hlsw-data-container">
          <!-- 频率数据 - 冷冻泵（feq02_2 一拖二） -->
          <span
            class="hlsw-data-item hlsw-freq-item"
            style="left: 69.5%; top: 43%;"
            :class="{ 'running': isFreezeRunning(1) }"
          >
            1#&nbsp;{{ getFreezeFreq(1) }} Hz
          </span>
          <span
            class="hlsw-data-item hlsw-freq-item"
            style="left: 69.5%; top: 54.5%;"
            :class="{ 'running': isFreezeRunning(2) }"
          >
            2#&nbsp;{{ getFreezeFreq(2) }} Hz
          </span>
          <span
            class="hlsw-data-item hlsw-freq-item"
            style="left: 69.5%; top: 66%;"
            :class="{ 'running': isPumpRunning2(feq01_2) }"
          >
            3#&nbsp;{{ formatFreq2(feq01_2) }} Hz
          </span>
          <span
            class="hlsw-data-item hlsw-freq-item"
            style="left: 69.5%; top: 78%;"
            :class="{ 'running': isPumpRunning2(feq03_2) }"
          >
            4#&nbsp;{{ formatFreq2(feq03_2) }} Hz
          </span>

          <!-- 频率数据 - 冷却泵（feq05_2 一拖二） -->
          <span
            class="hlsw-data-item hlsw-freq-item"
            style="left: 17.5%; top: 42.8%;"
            :class="{ 'running': isCoolingRunning(1) }"
          >
            1#&nbsp;{{ getCoolingFreq(1) }} Hz
          </span>
          <span
            class="hlsw-data-item hlsw-freq-item"
            style="left: 17.5%; top: 54.5%;"
            :class="{ 'running': isCoolingRunning(2) }"
          >
            2#&nbsp;{{ getCoolingFreq(2) }} Hz
          </span>
          <span
            class="hlsw-data-item hlsw-freq-item"
            style="left: 17.5%; top: 66%;"
            :class="{ 'running': isPumpRunning2(feq04_2) }"
          >
            3#&nbsp;{{ formatFreq2(feq04_2) }} Hz
          </span>
          <span
            class="hlsw-data-item hlsw-freq-item"
            style="left: 17.5%; top: 78%;"
            :class="{ 'running': isPumpRunning2(feq06_2) }"
          >
            4#&nbsp;{{ formatFreq2(feq06_2) }} Hz
          </span>

          <!-- 机组名称 -->
          <span
            class="hlsw-data-item hlsw-jz-number"
            style="left: 44.5%; top: 44.5%;"
            :style="{ color: Number(JZ_status_2) === 1 ? '#00cc00' : 'black' }"
          >
            1#
          </span>
          <span
            class="hlsw-data-item hlsw-jz-number"
            style="left: 44.5%; top: 60.8%;"
            :style="{ color: Number(JZ_status1_2) === 1 ? '#00cc00' : 'black' }"
          >
            2#
          </span>
          <span
            class="hlsw-data-item hlsw-jz-number"
            style="left: 44.5%; top: 77.2%;"
            :style="{ color: Number(JZ_status2_2) === 1 ? '#00cc00' : 'black' }"
          >
            3#
          </span>

          <!-- 机组状态 -->
          <span
            class="hlsw-data-item hlsw-jz-status"
            style="left: 43%; top: 49.5%;"
            :style="{ color: Number(JZ_status_2) === 1 ? '#00cc00' : 'black', textAlign: 'center' }"
          >
            {{ Number(JZ_status_2) === 1 ? '正在运行中' : '螺杆机组' }}
          </span>
          <span
            class="hlsw-data-item hlsw-jz-status"
            style="left: 43%; top: 65.8%;"
            :style="{ color: Number(JZ_status1_2) === 1 ? '#00cc00' : 'black', textAlign: 'center' }"
          >
            {{ Number(JZ_status1_2) === 1 ? '正在运行中' : '离心机组' }}
          </span>
          <span
            class="hlsw-data-item hlsw-jz-status"
            style="left: 43%; top: 82%;"
            :style="{ color: Number(JZ_status2_2) === 1 ? '#00cc00' : 'black', textAlign: 'center' }"
          >
            {{ Number(JZ_status2_2) === 1 ? '正在运行中' : '离心机组' }}
          </span>

          <!-- 温度数据 -->
          <span class="hlsw-data-item" style="left: 52%; top: 46%;">&nbsp;NaN °C</span>
          <span class="hlsw-data-item" style="left: 52%; top: 49%;">&nbsp;NaN °C</span>
          <span class="hlsw-data-item" style="left: 35%; top: 46%;">&nbsp;NaN °C</span>
          <span class="hlsw-data-item" style="left: 35%; top: 49%;">&nbsp;NaN °C</span>

          <span class="hlsw-data-item" style="left: 52%; top: 62.8%;">&nbsp;{{ C2_EvapIn_2 }} °C</span>
          <span class="hlsw-data-item" style="left: 52%; top: 65.5%;">&nbsp;{{ C2_EvapOut_2 }} °C</span>
          <span class="hlsw-data-item" style="left: 35%; top: 62.8%;">&nbsp;{{ C2_CondIn_2 }} °C</span>
          <span class="hlsw-data-item" style="left: 35%; top: 65.5%;">&nbsp;{{ C2_CondOut_2 }} °C</span>

          <span class="hlsw-data-item" style="left: 52%; top: 81.6%;">&nbsp;{{ C3_EvapIn_2 }} °C</span>
          <span class="hlsw-data-item" style="left: 52%; top: 84.5%;">&nbsp;{{ C3_EvapOut_2 }} °C</span>
          <span class="hlsw-data-item" style="left: 35%; top: 81.6%;">&nbsp;{{ C3_CondIn_2 }} °C</span>
          <span class="hlsw-data-item" style="left: 35%; top: 84.5%;">&nbsp;{{ C3_CondOut_2 }} °C</span>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'HLSWLyzYm',
  data() {
    return {
      currentTime: '',
      username: '用户',
      chartIntervals: [],
      showDeviceList: false,
      showDeviceDetailModal: false,
      selectedDevice: null,
      frequency: 50,

      // 当前显示的站：'I' 或 'II'
      currentStation: 'I',

      devices: [
        { id: 1, name: '冷冻水泵#1', type: '水泵', area: 'A8-CMF一期', status: 'online', statusText: '运行中', power: '450', runTime: '/' },
        { id: 2, name: '冷冻水泵#2', type: '水泵', area: 'A8-CMF一期', status: 'online', statusText: '运行中', power: '380', runTime: '/' },
        { id: 3, name: '冷冻水泵#3', type: '水泵', area: 'A8-CMF一期', status: 'online', statusText: '运行中', power: '120', runTime: '/' },
        { id: 4, name: '冷却水泵#1', type: '水泵', area: 'A8-CMF一期', status: 'online', statusText: '运行中', power: '120', runTime: '/' },
        { id: 5, name: '冷却水泵#2', type: '水泵', area: 'A8-CMF一期', status: 'online', statusText: '运行中', power: '180', runTime: '/' },
        { id: 6, name: '冷却水泵#3', type: '水泵', area: 'A8-CMF一期', status: 'online', statusText: '运行中', power: '180', runTime: '/' },
        { id: 7, name: '75KW/丹佛斯冷冻水泵', type: '水泵', area: 'A8-CMF二期', status: 'online', statusText: '运行中', power: '90', runTime: '/' },
        { id: 8, name: '75KW/ABB冷冻水泵', type: '水泵', area: 'A8-CMF二期', status: 'online', statusText: '运行中', power: '150', runTime: '/' },
        { id: 9, name: '45KW/ABB冷冻水泵', type: '水泵', area: 'A8-CMF二期', status: 'online', statusText: '运行中', power: '220', runTime: '/' },
        { id: 10, name: '75KW/丹佛斯冷却水泵', type: '水泵', area: 'A8-CMF二期', status: 'online', statusText: '运行中', power: '320', runTime: '/' },
        { id: 11, name: '75KW/ABB冷却水泵', type: '水泵', area: 'A8-CMF二期', status: 'online', statusText: '运行中', power: '320', runTime: '/' },
        { id: 12, name: '45KW/ABB冷却水泵', type: '水泵', area: 'A8-CMF二期', status: 'online', statusText: '运行中', power: '320', runTime: '/' }
      ],

      alarmDevices: [
        { id: 1, deviceId: 3, deviceName: '冷却水泵1', area: '2#机房', reason: '温度过高', time: '2024-06-18 14:30:25', status: 'warning', statusText: '未处理' },
        { id: 2, deviceId: 10, deviceName: '空压机', area: '3#车间', reason: '压力异常', time: '2024-06-18 14:25:10', status: 'warning', statusText: '未处理' }
      ],

      showAlarmDetailModal: false,

      // I期冷源站数据
      hlswImage: 'https://hpc.cnhopo.com/hpcimgs/20251225_f0adffa1_HLSWnew.png',
      hlswTimer: null,
      hlswScrollTimer: null,
      cookieValue: '',

      feq01: '', feq02: '', feq03: '', feq04: '', feq05: '', feq06: '',

      Evap_inlet_water_t: '', Evap_out_water_Allt: '', Cond_inlet_water_t: '', Cond_out_water_t: '',
      Evap_inlet_water_t1: '', Evap_out_water_Allt1: '', Cond_inlet_water_t1: '', Cond_out_water_t1: '',
      Evap_inlet_water_t2: '', Evap_out_water_Allt2: '', Cond_inlet_water_t2: '', Cond_out_water_t2: '',

      JZ_status: '', JZ_status1: '', JZ_status2: '',

      C1_Compressor_load_one: '', C1_Compressor_load_two: '',
      C2_Compressor_load_one: '', C2_Compressor_load_two: '',
      C3_Compressor_load_one: '', C3_Compressor_load_two: '',

      pumpStatus: {
        HLSW_HN1013_SB_1: '', HLSW_HN1013_SB_2: '', HLSW_HN1013_SB_3: '',
        HLSW_HN1013_SB_4: '', HLSW_HN1013_SB_5: '', HLSW_HN1013_SB_6: ''
      },
      pumpMap: {
        HLSW_HN1013_SB_1: '1#冷冻泵', HLSW_HN1013_SB_2: '2#冷冻泵', HLSW_HN1013_SB_3: '3#冷冻泵',
        HLSW_HN1013_SB_4: '1#冷却泵', HLSW_HN1013_SB_5: '2#冷却泵', HLSW_HN1013_SB_6: '3#冷却泵'
      },

      hlswBaseMsgList: [],
      hlswInfiniteMsgList: [],
      hlswScrollOffset: 0,
      hlswItemHeight: 24,
      hlswShowCount: 5,

      // II期冷源站数据
      hlsw2Image: 'https://hpc.cnhopo.com/hpcimgs/20260623_dad97e12_HLSW2.png',
      hlsw2Timer: null,
      feq01_2: '', feq02_2: '', feq03_2: '', feq04_2: '', feq05_2: '', feq06_2: '',
      C2_EvapIn_2: '', C2_EvapOut_2: '', C2_CondIn_2: '', C2_CondOut_2: '',
      C3_EvapIn_2: '', C3_EvapOut_2: '', C3_CondIn_2: '', C3_CondOut_2: '',
      JZ_status_2: '', JZ_status1_2: '', JZ_status2_2: '',

      // II期冷源站 - 水泵开关信号 (0=开启, 1=关闭)
      Freeze_1: '',  // 冷冻泵1#
      Freeze_2: '',  // 冷冻泵2#
      Cooling_1: '', // 冷却泵1#
      Cooling_2: ''  // 冷却泵2#
    };
  },
  mounted() {
    this.updateTime();
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user.user_name) {
      this.username = user.user_name;
    }
    this.cookieValue = user.cookie || '';
    setInterval(this.updateTime, 1000);

    // I期数据
    this.hlswFetchData();
    this.hlswFetchPumpData();
    this.hlswStartTimer();
    this.hlswStartMsgScroll();

    // II期数据
    this.hlsw2FetchData();
    this.hlsw2StartTimer();
  },
  beforeDestroy() {
    this.chartIntervals.forEach(interval => clearInterval(interval));
    this.hlswClearTimer();
    this.hlswClearMsgScroll();
    if (this.hlsw2Timer) clearInterval(this.hlsw2Timer);
  },
  methods: {
    updateTime() {
      const now = new Date();
      this.currentTime = now.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },

    // 切换冷源站
    switchStation() {
      this.currentStation = this.currentStation === 'I' ? 'II' : 'I';
    },

    toggleDeviceList() {
      this.showDeviceList = !this.showDeviceList;
    },
    closeDeviceList() {
      this.showDeviceList = false;
    },
    showDeviceDetail(device) {
      this.selectedDevice = device;
      this.showDeviceDetailModal = true;
      this.frequency = 50;
    },
    closeDeviceDetail() {
      this.showDeviceDetailModal = false;
      this.selectedDevice = null;
    },
    startDevice() {
      if (this.selectedDevice) {
        this.selectedDevice.status = 'online';
        this.selectedDevice.statusText = '运行中';
        alert(`已开启设备: ${this.selectedDevice.name}`);
      }
    },
    stopDevice() {
      if (this.selectedDevice) {
        this.selectedDevice.status = 'offline';
        this.selectedDevice.statusText = '离线';
        alert(`已关闭设备: ${this.selectedDevice.name}`);
      }
    },
    updateFrequency() {
      if (this.selectedDevice) {
        alert(`已更新设备 ${this.selectedDevice.name} 的运行频率为 ${this.frequency}%`);
      }
    },
    closeAlarmDetail() {
      this.showAlarmDetailModal = false;
    },
    handleCommand(command) {
      if (command === 'logout') {
        this.logout();
      }
    },
    logout() {
      this.$confirm('确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'dark-message-box'
      }).then(() => {
        localStorage.removeItem('user');
        this.$router.push('/');
      }).catch(() => {});
    },

    // ========== 设备状态更新方法 ==========
// 更新I期设备状态和功率（用功率判断运行状态）
    updateDevicesStatus1(data) {
      const deviceMap = {
        1: { pt: 'pt01' },
        2: { pt: 'pt02' },
        3: { pt: 'pt03' },
        4: { pt: 'pt04' },
        5: { pt: 'pt05' },
        6: { pt: 'pt06' }
      };

      Object.keys(deviceMap).forEach(id => {
        const device = this.devices.find(d => d.id === Number(id));
        if (device) {
          const keys = deviceMap[id];
          const ptValue = data[keys.pt];

          // 更新功率（保留两位小数）
          if (ptValue !== undefined && ptValue !== null && ptValue !== '') {
            const ptNum = parseFloat(ptValue);
            device.power = isNaN(ptNum) ? '0' : String(Math.round(ptNum * 100) / 100);

            // 用功率判断运行状态：功率 > 3KW 为运行中，否则为离线
            if (ptNum > 3) {
              device.status = 'online';
              device.statusText = '运行中';
            } else {
              device.status = 'offline';
              device.statusText = '离线';
            }
          }
        }
      });
    },

// 更新II期设备状态和功率（用功率判断运行状态）
    updateDevicesStatus2(data) {
      const deviceMap = {
        7: { pt: 'pt01' },
        8: { pt: 'pt02' },
        9: { pt: 'pt03' },
        10: { pt: 'pt04' },
        11: { pt: 'pt05' },
        12: { pt: 'pt06' }
      };

      Object.keys(deviceMap).forEach(id => {
        const device = this.devices.find(d => d.id === Number(id));
        if (device) {
          const keys = deviceMap[id];
          const ptValue = data[keys.pt];

          // 更新功率（保留两位小数）
          if (ptValue !== undefined && ptValue !== null && ptValue !== '') {
            const ptNum = parseFloat(ptValue);
            device.power = isNaN(ptNum) ? '0' : String(Math.round(ptNum * 100) / 100);

            // 用功率判断运行状态：功率 > 3KW 为运行中，否则为离线
            if (ptNum > 3) {
              device.status = 'online';
              device.statusText = '运行中';
            } else {
              device.status = 'offline';
              device.statusText = '离线';
            }
          }
        }
      });
    },

    // ========== I期格式化函数 ==========
    formatFreq(value) {
      if (value === '' || value === null || value === undefined || isNaN(Number(value))) {
        return 'NaN';
      }
      const num = Number(value);
      if (num < 0 || Object.is(num, -0)) {
        return 'NaN';
      }
      return Math.floor(num);
    },

    // ========== II期格式化函数 ==========
    formatFreq2(value) {
      if (value === '' || value === null || value === "0" || value === '-' ||value === undefined || isNaN(Number(value))) {
        return 'NaN';
      }
      const num = Number(value);
      if (num < 0) return 'NaN';
      if (num === 0) return '0';
      return Math.floor(num);
    },

    isPumpRunning2(value) {
      if (value === '' || value === null || value === undefined || isNaN(Number(value))) {
        return false;
      }
      return Number(value) > 0;
    },

    // ========== II期 - 冷冻泵/冷却泵判断方法 ==========
    // 判断冷冻泵1#是否开启（Freeze_1 === 0 表示开启）
    isFreeze1Running() {
      const val = String(this.Freeze_1).trim();
      if (val === '' || val === null || val === undefined) return false;
      return Number(val) === 0;
    },

    // 判断冷冻泵2#是否开启（Freeze_2 === 0 表示开启）
    isFreeze2Running() {
      const val = String(this.Freeze_2).trim();
      if (val === '' || val === null || val === undefined) return false;
      return Number(val) === 0;
    },

    // 判断冷却泵1#是否开启（Cooling_1 === 0 表示开启）
    isCooling1Running() {
      const val = String(this.Cooling_1).trim();
      if (val === '' || val === null || val === undefined) return false;
      return Number(val) === 0;
    },

    // 判断冷却泵2#是否开启（Cooling_2 === 0 表示开启）
    isCooling2Running() {
      const val = String(this.Cooling_2).trim();
      if (val === '' || val === null || val === undefined) return false;
      return Number(val) === 0;
    },

    // 判断值是否无效（"--" 或 "-" 表示数据未采集）
    isInvalidValue(value) {
      return value === '--' || value === '-' || value === '' || value === null || value === undefined;
    },

    // 获取冷冻泵显示频率（仅当对应泵开启时显示）
    getFreezeFreq(pumpIndex) {
      const rawValue = this.feq02_2;
      // 如果原始值是 "--" 或无效数据，返回 'NaN'
      if (this.isInvalidValue(rawValue)) {
        return 'NaN';
      }
      const freq = Number(rawValue);
      // 如果转换后是NaN，返回'NaN'
      if (isNaN(freq)) return 'NaN';
      // 如果频率小于等于0，返回 '0'
      if (freq <= 0) return '0';
      if (pumpIndex === 1 && this.isFreeze1Running()) {
        return Math.floor(freq);
      }
      if (pumpIndex === 2 && this.isFreeze2Running()) {
        return Math.floor(freq);
      }
      return '0';
    },

    // 获取冷却泵显示频率（仅当对应泵开启时显示）
    getCoolingFreq(pumpIndex) {
      const rawValue = this.feq05_2;
      // 如果原始值是 "--" 或无效数据，返回 'NaN'
      if (this.isInvalidValue(rawValue)) {
        return 'NaN';
      }
      const freq = Number(rawValue);
      // 如果转换后是NaN，返回'NaN'
      if (isNaN(freq)) return 'NaN';
      // 如果频率小于等于0，返回 '0'
      if (freq <= 0) return '0';
      if (pumpIndex === 1 && this.isCooling1Running()) {
        return Math.floor(freq);
      }
      if (pumpIndex === 2 && this.isCooling2Running()) {
        return Math.floor(freq);
      }
      return '0';
    },

    // 判断冷冻泵是否应该显示绿色（有频率且对应泵开启）
    isFreezeRunning(pumpIndex) {
      const rawValue = this.feq02_2;
      // 如果原始值是 "--" 或无效数据，不显示绿色
      if (this.isInvalidValue(rawValue)) {
        return false;
      }
      const freq = Number(rawValue);
      // 频率必须大于0才显示绿色（0不显示绿色）
      if (isNaN(freq) || freq <= 0) return false;
      if (pumpIndex === 1 && this.isFreeze1Running()) return true;
      if (pumpIndex === 2 && this.isFreeze2Running()) return true;
      return false;
    },

    // 判断冷却泵是否应该显示绿色（有频率且对应泵开启）
    isCoolingRunning(pumpIndex) {
      const rawValue = this.feq05_2;
      // 如果原始值是 "--" 或无效数据，不显示绿色
      if (this.isInvalidValue(rawValue)) {
        return false;
      }
      const freq = Number(rawValue);
      // 频率必须大于0才显示绿色（0不显示绿色）
      if (isNaN(freq) || freq <= 0) return false;
      if (pumpIndex === 1 && this.isCooling1Running()) return true;
      if (pumpIndex === 2 && this.isCooling2Running()) return true;
      return false;
    },

    // ========== I期冷源站方法 ==========
    hlswStartTimer() {
      this.hlswTimer = setInterval(() => {
        this.hlswFetchData();
        this.hlswFetchPumpData();
      }, 20000);
    },
    hlswClearTimer() {
      if (this.hlswTimer) clearInterval(this.hlswTimer);
    },

    hlswStartMsgScroll() {
      this.hlswScrollTimer = setInterval(() => {
        this.hlswScrollOffset += this.hlswItemHeight;
        const singleListHeight = this.hlswBaseMsgList.length * this.hlswItemHeight;
        if (singleListHeight > 0 && this.hlswScrollOffset >= singleListHeight) {
          this.hlswScrollOffset = this.hlswScrollOffset - singleListHeight;
        }
      }, 4000);
    },
    hlswClearMsgScroll() {
      if (this.hlswScrollTimer) clearInterval(this.hlswScrollTimer);
    },

    hlswGenerateMsgList() {
      const jzMsg = [
        `1#机组${Number(this.JZ_status) === 1 ? '正在运行' : '未开机'}`,
        `2#机组${Number(this.JZ_status1) === 1 ? '正在运行' : '未开机'}`,
        `3#机组${Number(this.JZ_status2) === 1 ? '正在运行' : '未开机'}`,
      ];

      const pumpMsg = [];
      Object.keys(this.pumpMap).forEach(pumpId => {
        const pumpName = this.pumpMap[pumpId];
        const pumpState = this.pumpStatus[pumpId];
        pumpMsg.push(`${pumpName}${pumpState === '开启' ? '正在运行' : '未开机'}`);
      });

      this.hlswBaseMsgList = [...jzMsg, ...pumpMsg];
      this.hlswInfiniteMsgList = [...this.hlswBaseMsgList, ...this.hlswBaseMsgList, ...this.hlswBaseMsgList];
    },

    hlswFetchData() {
      fetch("https://hpc.cnhopo.com/otherApi/data/get_hlsw01_data", {
        method: 'GET',
        credentials: 'include'
      })
        .then(res => res.json())
        .then(res => {
          if (res.code === 200) {
            const data = res.data || {};
            this.feq01 = data.feq01 || '';
            this.feq02 = data.feq02 || '';
            this.feq03 = data.feq03 || '';
            this.feq04 = data.feq04 || '';
            this.feq05 = data.feq05 || '';
            this.feq06 = data.feq06 || '';

            this.Evap_inlet_water_t = data.Evap_inlet_water_t || '';
            this.Evap_out_water_Allt = data.Evap_out_water_Allt || '';
            this.Cond_inlet_water_t = data.Cond_inlet_water_t || '';
            this.Cond_out_water_t = data.Cond_out_water_t || '';
            this.Evap_inlet_water_t1 = data.Evap_inlet_water_t1 || '';
            this.Evap_out_water_Allt1 = data.Evap_out_water_Allt1 || '';
            this.Cond_inlet_water_t1 = data.Cond_inlet_water_t1 || '';
            this.Cond_out_water_t1 = data.Cond_out_water_t1 || '';
            this.Evap_inlet_water_t2 = data.Evap_inlet_water_t2 || '';
            this.Evap_out_water_Allt2 = data.Evap_out_water_Allt2 || '';
            this.Cond_inlet_water_t2 = data.Cond_inlet_water_t2 || '';
            this.Cond_out_water_t2 = data.Cond_out_water_t2 || '';

            this.C1_Compressor_load_one = data.C1_Compressor_load_one || '';
            this.C1_Compressor_load_two = data.C1_Compressor_load_two || '';
            this.C2_Compressor_load_one = data.C2_Compressor_load_one || '';
            this.C2_Compressor_load_two = data.C2_Compressor_load_two || '';
            this.C3_Compressor_load_one = data.C3_Compressor_load_one || '';
            this.C3_Compressor_load_two = data.C3_Compressor_load_two || '';

            this.JZ_status = data.JZ_status || '';
            this.JZ_status1 = data.JZ_status1 || '';
            this.JZ_status2 = data.JZ_status2 || '';

            // 更新I期设备状态
            this.updateDevicesStatus1(data);

            this.hlswGenerateMsgList();
          }
        })
        .catch(err => {
          console.error('I期机组数据请求失败:', err);
        });
    },

    hlswFetchPumpData() {
      const validCookie = this.cookieValue ? this.cookieValue.trim() : '';
      if (!validCookie) {
        console.warn('Cookie值为空，无法请求泵数据');
        Object.keys(this.pumpStatus).forEach(pumpId => {
          this.pumpStatus[pumpId] = '关闭';
        });
        this.hlswGenerateMsgList();
        return;
      }

      const pumpIds = [
        'HLSW_HN1013_SB_1', 'HLSW_HN1013_SB_2', 'HLSW_HN1013_SB_3',
        'HLSW_HN1013_SB_4', 'HLSW_HN1013_SB_5', 'HLSW_HN1013_SB_6'
      ];

      const requestPromises = [];

      pumpIds.forEach(pumpId => {
        const promise = new Promise((resolve) => {
          const params = new URLSearchParams();
          params.append('equ_id', pumpId);

          fetch("/otherApi/get_vfd/?" + params.toString(), {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            },
            credentials: 'include',
            mode: 'cors'
          })
            .then(res => res.json())
            .then(res => {
              if (res.code === 200) {
                this.pumpStatus[pumpId] = res.data || '关闭';
              } else {
                this.pumpStatus[pumpId] = '关闭';
              }
              resolve();
            })
            .catch(err => {
              console.error(`${pumpId} 泵请求失败:`, err);
              this.pumpStatus[pumpId] = '关闭';
              resolve();
            });
        });
        requestPromises.push(promise);
      });

      Promise.all(requestPromises).then(() => {
        this.hlswGenerateMsgList();
      });
    },

    // ========== II期冷源站方法 ==========
    hlsw2FetchData() {
      fetch("https://hpc.cnhopo.com/otherApi/data/get_hlsw02_data", {
        method: 'GET',
        credentials: 'include'
      })
        .then(res => res.json())
        .then(res => {
          if (res.code === 200) {
            const data = res.data || {};
            this.feq01_2 = data.feq01 || '';
            this.feq02_2 = data.feq02 || '';
            this.feq03_2 = data.feq03 || '';
            this.feq04_2 = data.feq04 || '';
            this.feq05_2 = data.feq05 || '';
            this.feq06_2 = data.feq06 || '';

            // 水泵开关信号 (0=开启, 1=关闭)
            this.Freeze_1 = data.Freeze_1 !== undefined ? String(data.Freeze_1) : '';
            this.Freeze_2 = data.Freeze_2 !== undefined ? String(data.Freeze_2) : '';
            this.Cooling_1 = data.Cooling_1 !== undefined ? String(data.Cooling_1) : '';
            this.Cooling_2 = data.Cooling_2 !== undefined ? String(data.Cooling_2) : '';

            const formatTemp = (value) => {
              if (value === '' || value === null || value === undefined) return 'NaN';
              const num = Number(value);
              if (isNaN(num) || num <= 0) return 'NaN';
              return String(num);
            };

            this.C2_EvapIn_2 = formatTemp(data.C2_EvapIn);
            this.C2_EvapOut_2 = formatTemp(data.C2_EvapOut);
            this.C2_CondIn_2 = formatTemp(data.C2_CondIn);
            this.C2_CondOut_2 = formatTemp(data.C2_CondOut);
            this.C3_EvapIn_2 = formatTemp(data.C3_EvapIn);
            this.C3_EvapOut_2 = formatTemp(data.C3_EvapOut);
            this.C3_CondIn_2 = formatTemp(data.C3_CondIn);
            this.C3_CondOut_2 = formatTemp(data.C3_CondOut);

            this.JZ_status_2 = data.JZ_status || '';
            this.JZ_status1_2 = data.JZ_status1 || '';
            this.JZ_status2_2 = data.JZ_status2 || '';

            // 更新II期设备状态
            this.updateDevicesStatus2(data);
          }
        })
        .catch(err => console.error('II期数据请求失败:', err));
    },

    hlsw2StartTimer() {
      this.hlsw2Timer = setInterval(this.hlsw2FetchData, 20000);
    }
  }
};
</script>

<style scoped>
.energy-management-platform {
  width: 100vw;
  height: 100vh;
  background-image: url('../assets/img/shawushawu.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: #ffffff;
  font-family: 'Microsoft YaHei', 'Arial', sans-serif;
  overflow: hidden;
  position: relative;
}

:root {
  --primary-color: #00d4ff;
  --secondary-color: #28a745;
  --accent-color: #007bff;
  --warning-color: #ffc107;
  --danger-color: #dc3545;
  --text-color: #ffffff;
  --text-secondary: #b0c4de;
  --bg-primary: rgba(26, 35, 50, 0.2);
  --bg-secondary: rgba(0, 0, 0, 0.1);
  --border-color: rgba(0, 212, 255, 0.2);
  --shadow-color: rgba(0, 212, 255, 0.3);
}

.background-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.grid-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgba(0, 212, 255, 0.02) 1px, transparent 1px);
  background-size: 100px 100px;
}

.blue-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(0, 212, 255, 0.08) 0%, transparent 70%);
  border-radius: 50%;
  filter: blur(30px);
  z-index: 1;
}

/* 顶部标题栏 */
.top-header {
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding: 12px 30px;
  height: 70px;
  box-sizing: border-box;
  background: rgba(26, 35, 50, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 212, 255, 0.3);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.top-header:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 212, 255, 0.2);
  border-color: rgba(0, 212, 255, 0.4);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 30px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 15px;
}

.logo-icon {
  font-size: 32px;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.8);
}

.logo h2 {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  background: linear-gradient(90deg, #00d4ff, #007bff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.main-nav {
  margin-left: 30px;
}

.nav-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 10px;
}

.nav-item {
  margin: 0;
  padding: 0;
}

.nav-link {
  display: block;
  padding: 10px 20px;
  color: #b0c4de;
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.3s ease;
  position: relative;
}

.nav-link:hover {
  color: #00d4ff;
  background: rgba(0, 212, 255, 0.1);
}

.nav-link.active {
  color: #ffffff;
  background: rgba(0, 123, 255, 0.2);
  border: 1px solid rgba(0, 123, 255, 0.4);
  box-shadow: 0 0 15px rgba(0, 123, 255, 0.3);
}

.header-right {
  display: flex;
  align-items: center;
  gap: 30px;
}

.system-status {
  display: flex;
  align-items: center;
  gap: 20px;
}

.status-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #00ff00;
  animation: pulse 2s infinite;
}

.status-dot.online { background: #00ff00; }
.status-dot.warning { background: #ffc107; }
.status-dot.offline { background: #dc3545; }

.status-value {
  color: #00d4ff;
  font-weight: 600;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 15px;
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.user-info:hover {
  background: rgba(0, 212, 255, 0.2);
  border-color: rgba(0, 212, 255, 0.5);
}

.dark-dropdown-menu {
  background-color: #1a2332 !important;
  border: 1px solid rgba(0, 212, 255, 0.3) !important;
  padding: 5px 0 !important;
}

.dark-dropdown-menu .el-dropdown-menu__item {
  color: #b0c4de !important;
}

.dark-dropdown-menu .el-dropdown-menu__item:hover {
  background-color: rgba(0, 212, 255, 0.1) !important;
  color: #00d4ff !important;
}

.dark-dropdown-menu .popper__arrow::after {
  border-bottom-color: #1a2332 !important;
}

.user-avatar {
  font-size: 18px;
}

@keyframes pulse {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.2); opacity: 0.7; }
  100% { transform: scale(1); opacity: 1; }
}

/* ========== 弹窗样式 ========== */
.device-list-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  z-index: 999;
}

.modal-content {
  position: relative;
  background: rgba(26, 35, 50, 0.95);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 12px;
  width: 90%;
  max-width: 1200px;
  max-height: 80vh;
  overflow: hidden;
  z-index: 1001;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border-bottom: 1px solid rgba(0, 212, 255, 0.3);
  background: rgba(13, 20, 30, 0.8);
}

.modal-header h2 {
  margin: 0;
  color: #00d4ff;
  font-size: 24px;
  font-weight: 700;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.5);
}

.close-btn {
  font-size: 30px;
  color: #b0c4de;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.3);
}

.close-btn:hover {
  color: #ffffff;
  background: rgba(220, 53, 69, 0.5);
  transform: rotate(90deg);
}

.modal-body {
  padding: 30px;
  max-height: calc(80vh - 100px);
  overflow-y: auto;
}

.device-table-container {
  overflow-x: auto;
}

.device-table {
  width: 100%;
  border-collapse: collapse;
  background: rgba(13, 20, 30, 0.5);
  border-radius: 8px;
  overflow: hidden;
}

.device-table th,
.device-table td {
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid rgba(0, 212, 255, 0.2);
  color: #ffffff;
  font-size: 14px;
}

.device-table th {
  background: rgba(0, 212, 255, 0.1);
  font-weight: 600;
  color: #00d4ff;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.device-table tr:hover {
  background: rgba(0, 212, 255, 0.05);
}

.device-table tr:last-child td {
  border-bottom: none;
}

.status-badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-badge.online {
  background: rgba(40, 167, 69, 0.2);
  color: #28a745;
  border: 1px solid rgba(40, 167, 69, 0.5);
}

.status-badge.warning {
  background: rgba(255, 193, 7, 0.2);
  color: #ffc107;
  border: 1px solid rgba(255, 193, 7, 0.5);
}

.status-badge.offline {
  background: rgba(220, 53, 69, 0.2);
  color: #dc3545;
  border: 1px solid rgba(220, 53, 69, 0.5);
}

.action-btn {
  padding: 6px 16px;
  background: rgba(0, 212, 255, 0.2);
  border: 1px solid rgba(0, 212, 255, 0.5);
  border-radius: 6px;
  color: #00d4ff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.action-btn:hover {
  background: rgba(0, 212, 255, 0.4);
  box-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
  transform: translateY(-2px);
}

.device-detail-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.device-detail-modal .modal-content {
  position: relative;
  background: rgba(26, 35, 50, 0.95);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow: hidden;
  z-index: 1001;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
}

.device-detail-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border-bottom: 1px solid rgba(0, 212, 255, 0.3);
  background: rgba(13, 20, 30, 0.8);
}

.device-detail-modal .modal-header h2 {
  margin: 0;
  color: #00d4ff;
  font-size: 24px;
  font-weight: 700;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.5);
}

.device-detail-modal .close-btn {
  font-size: 30px;
  color: #b0c4de;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.3);
}

.device-detail-modal .close-btn:hover {
  color: #ffffff;
  background: rgba(220, 53, 69, 0.5);
  transform: rotate(90deg);
}

.device-detail-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.device-basic-info {
  background: rgba(13, 20, 30, 0.9);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 12px;
  padding: 25px;
  backdrop-filter: blur(5px);
}

.device-control-section {
  background: rgba(13, 20, 30, 0.9);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 12px;
  padding: 25px;
  backdrop-filter: blur(5px);
}

.section-title {
  margin: 0 0 20px 0;
  color: #00d4ff;
  font-size: 20px;
  font-weight: 700;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.5);
  border-bottom: 1px solid rgba(0, 212, 255, 0.2);
  padding-bottom: 10px;
}

.control-subtitle {
  margin: 0 0 15px 0;
  color: #b0c4de;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.info-label {
  color: #8892b0;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
}

.info-value.highlight {
  color: #00d4ff;
  font-size: 18px;
  text-shadow: 0 0 8px rgba(0, 212, 255, 0.5);
}

.control-section {
  margin-bottom: 25px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(0, 212, 255, 0.1);
}

.control-section:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.control-buttons {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin: 0 20px;
  flex-wrap: wrap;
}

.control-btn {
  padding: 12px 30px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 120px;
}

.control-btn.start-btn {
  background: linear-gradient(135deg, rgba(40, 167, 69, 0.8), rgba(32, 144, 58, 0.8));
  color: #ffffff;
  border: 1px solid rgba(40, 167, 69, 0.6);
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.2);
}

.control-btn.start-btn:hover {
  background: linear-gradient(135deg, rgba(40, 167, 69, 1), rgba(32, 144, 58, 1));
  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);
  transform: translateY(-2px);
}

.control-btn.stop-btn {
  background: linear-gradient(135deg, rgba(220, 53, 69, 0.8), rgba(200, 35, 50, 0.8));
  color: #ffffff;
  border: 1px solid rgba(220, 53, 69, 0.6);
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.2);
}

.control-btn.stop-btn:hover {
  background: linear-gradient(135deg, rgba(220, 53, 69, 1), rgba(200, 35, 50, 1));
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);
  transform: translateY(-2px);
}

.frequency-control {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.frequency-input-group {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.frequency-input-container {
  display: flex;
  align-items: center;
  gap: 15px;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 8px;
  padding: 10px 15px;
}

.frequency-input {
  flex: 1;
  padding: 12px 20px;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 6px;
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  transition: all 0.3s ease;
}

.frequency-input:focus {
  outline: none;
  border-color: #00d4ff;
  box-shadow: 0 0 15px rgba(0, 212, 255, 0.3);
  background: rgba(0, 0, 0, 0.5);
}

.frequency-unit {
  color: #00d4ff;
  font-weight: 700;
  font-size: 20px;
  text-shadow: 0 0 8px rgba(0, 212, 255, 0.5);
  min-width: 30px;
  text-align: center;
}

.frequency-btn {
  padding: 12px 30px;
  background: linear-gradient(135deg, rgba(0, 212, 255, 0.3), rgba(0, 180, 220, 0.3));
  border: 1px solid rgba(0, 212, 255, 0.6);
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 15px rgba(0, 212, 255, 0.2);
  white-space: nowrap;
}

.alarm-detail-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.alarm-detail-modal .modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  z-index: 999;
}

.alarm-detail-modal .modal-content {
  position: relative;
  background: rgba(26, 35, 50, 0.95);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow: hidden;
  z-index: 1001;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
}

.alarm-detail-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border-bottom: 1px solid rgba(0, 212, 255, 0.3);
  background: rgba(13, 20, 30, 0.8);
}

.alarm-detail-modal .modal-header h2 {
  margin: 0;
  color: #00d4ff;
  font-size: 24px;
  font-weight: 700;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.5);
}

.alarm-detail-modal .close-btn {
  font-size: 30px;
  color: #b0c4de;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.3);
}

.alarm-detail-modal .close-btn:hover {
  color: #ffffff;
  background: rgba(220, 53, 69, 0.5);
  transform: rotate(90deg);
}

.alarm-detail-modal .modal-body {
  padding: 30px;
  max-height: calc(80vh - 100px);
  overflow: auto;
}

.alarm-detail-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.alarm-table-container {
  width: 100%;
  overflow-x: auto;
  background: rgba(13, 20, 30, 0.5);
  border: 1px solid rgba(0, 123, 255, 0.3);
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.alarm-table {
  width: 100%;
  border-collapse: collapse;
  color: #ffffff;
}

.alarm-table th {
  background: rgba(0, 123, 255, 0.2);
  border-bottom: 1px solid rgba(0, 123, 255, 0.3);
  padding: 12px 15px;
  text-align: left;
  font-size: 14px;
  font-weight: 700;
  color: #00d4ff;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.5);
}

.alarm-table td {
  border-bottom: 1px solid rgba(0, 123, 255, 0.1);
  padding: 12px 15px;
  font-size: 14px;
}

.alarm-table tbody tr:hover {
  background: rgba(0, 123, 255, 0.1);
  cursor: pointer;
}

.alarm-table td:last-child {
  text-align: center;
}

.modal-body::-webkit-scrollbar,
.device-table-container::-webkit-scrollbar,
.alarm-table-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.modal-body::-webkit-scrollbar-track,
.device-table-container::-webkit-scrollbar-track,
.alarm-table-container::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}

.modal-body::-webkit-scrollbar-thumb,
.device-table-container::-webkit-scrollbar-thumb,
.alarm-table-container::-webkit-scrollbar-thumb {
  background: rgba(0, 212, 255, 0.5);
  border-radius: 4px;
}

.modal-body::-webkit-scrollbar-thumb:hover,
.device-table-container::-webkit-scrollbar-thumb:hover,
.alarm-table-container::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 212, 255, 0.8);
}

/* ========== 主要内容区域 ========== */
.main-content {
  position: relative;
  z-index: 2;
  padding: 0 !important;
  height: calc(100vh - 70px);
  overflow: hidden;
  box-sizing: border-box;
}

/* ========== 切换按钮 - 红框位置 ========== */
.station-switch-btn {
  position: absolute;
  right: 30px;
  top: 15px;
  z-index: 10;
  padding: 8px 20px;
  background: linear-gradient(135deg, rgba(0, 212, 255, 0.25), rgba(0, 123, 255, 0.25));
  border: 1px solid rgba(0, 212, 255, 0.6);
  border-radius: 20px;
  color: black;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 15px rgba(0, 212, 255, 0.2);
  display: flex;
  align-items: center;
  gap: 8px;
}

.station-switch-btn:hover {
  background: linear-gradient(135deg, rgba(0, 212, 255, 0.4), rgba(0, 123, 255, 0.4));
  box-shadow: 0 6px 25px rgba(0, 212, 255, 0.4);
  transform: translateY(-2px) scale(1.02);
  border-color: rgba(0, 212, 255, 0.9);
}

.station-switch-btn:active {
  transform: scale(0.95);
}

.switch-icon {
  font-size: 16px;
}

/* ========== HLSW监控样式 ========== */
.hlsw-monitor-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 0;
  overflow: hidden;
}

.hlsw-full-image {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: block;
  z-index: 1;
  object-fit: fill;
}

.hlsw-data-container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.hlsw-data-item {
  position: absolute;
  padding: 5px 10px;
  color: black;
  border-radius: 4px;
  font-weight: bold;
  font-size: 13px;
  white-space: nowrap;
}

.hlsw-freq-item.running {
  color: #00cc00;
}

.hlsw-jz-number {
  display: inline-block;
  width: 40px;
  text-align: center;
  box-sizing: border-box;
}

.hlsw-jz-status {
  display: inline-block;
  width: 90px;
  box-sizing: border-box;
}

.hlsw-msg-box {
  position: absolute;
  left: 66%;
  top: 25.5%;
  width: 280px;
  height: 120px;
  overflow: hidden;
  z-index: 3;
  text-align: left;
}

.hlsw-msg-scroll {
  transition: transform 0.6s ease-out;
  will-change: transform;
}

.hlsw-msg-item {
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
  margin: 0;
  padding: 0 10px;
  text-align: left;
  width: 100%;
  box-sizing: border-box;
}

.hlsw-msg-item.msg-running {
  color: #00cc00;
}

.hlsw-msg-item.msg-stopped {
  color: #ff0000;
}

.hlsw-msg-item:not(.msg-running):not(.msg-stopped) {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/views/HLSWLyzYm.vue